export default "__VITE_ASSET__Ct_YoPLq__"